import * as React from 'react';

import { ChipItem } from './chip-item/chip-item.tsx';

import './chip-group.css';

interface ChipGroupProps
  extends Omit<React.HTMLAttributes<HTMLDivElement>, 'onClick'> {
  chips: Array<string>;
  size?: 'small' | 'medium' | 'large';
  kind?: 'neutral' | 'color' | 'danger' | 'disabled';
  disabled?: boolean;
  onClick?: (chip: string) => void;
}

const ChipGroup = React.forwardRef<HTMLDivElement, ChipGroupProps>(
  ({ chips, size = 'small', kind = 'color', disabled, onClick, ...props }, ref) => {
    const [internalChips, setInternalChips] = React.useState(chips);

    React.useLayoutEffect(() => {
      setInternalChips(chips);
    }, [chips]);

    return (
      <div className={`chip-group cg-${size}`} ref={ref} {...props}>
        {internalChips.map(chip => {
          return (
            <ChipItem
              label={chip}
              key={chip}
              size={size}
              kind={kind}
              disabled={disabled}
              onClick={() => {
                if (disabled) return;

                onClick?.(chip);
                kind !== 'disabled' &&
                  setInternalChips(
                    internalChips.filter(chipV => chipV !== chip),
                  );
              }}
            />
          );
        })}
      </div>
    );
  },
);

export { ChipGroup };
